import { environment } from "src/environments/environment";

//export var url="http://localhost/web/biofruit/";

//export var url="https://mispracticasangular.000webhostapp.com/php/"

export var url = "https://vpe-app.com/ws/";
export var url_ws ="https://vpe-app.com/ws/";
export var urlUpload = "https://vpe-app.com/ws/upload/";

export var valorAnd =" "; 
export var valorOr =","; 